export default function ClientNotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <div className="space-y-6 pb-32 text-center">
        <h1 className="text-8xl font-bold text-foreground">404</h1>
        <p className="text-2xl text-muted-foreground">Client not found</p>
        <p className="text-muted-foreground">
          We couldn&apos;t find a client for this address. Please check the URL
          and try again.
        </p>
      </div>
    </div>
  )
}
